import { render, staticRenderFns } from "./ReceiptLogo.vue?vue&type=template&id=c254fe26&"
import script from "./ReceiptLogo.vue?vue&type=script&lang=js&"
export * from "./ReceiptLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports